<template>
  <div>
    <v-snackbar color="deep-orange"
                right
                top
                v-model="validationSnackbar">
      {{ $t('thereAreItemsThatRequireYourAttention') }}
    </v-snackbar>

    <top-header v-bind:title="$t('newDate')">
      <header-button icon="mdi-close"
                     slot="left-button"
                     v-bind:label="$t('cancel')"
                     v-bind:to="{ name: 'booking-event', params: { id: eventId } }" />
      <header-button icon="mdi-check"
                     right
                     slot="right-button"
                     v-bind:label="$t('save')"
                     v-on:click="createEventDate" />
    </top-header>

    <v-progress-linear indeterminate
                       v-bind:active="loading" />

    <v-container>
      <v-row>
        <v-col cols="12"
               lg="6">
          <event-date-details-card ref="eventDateDetailsCard"
                                   v-bind:event-date="eventDate" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  import EventDateDetailsCard from '@/components/booking/EventDateDetailsCard.vue'
  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'

  export default {
    async beforeRouteUpdate(to, from, next) {
      this.eventDate.eventId = parseInt(to.params.eventId)

      next()
    },
    components: {
      EventDateDetailsCard,
      HeaderButton,
      TopHeader
    },
    computed: {
      eventId() {
        return this.eventDate?.eventId
      }
    },
    async created() {
      this.eventDate.eventId = parseInt(this.$route.params.eventId)
    },
    data: () => ({
      eventDate: {
        eventId: null
      },
      loading: false,
      validationSnackbar: false
    }),
    methods: {
      async createEventDate() {
        if (!this.$refs.eventDateDetailsCard.validate()) {
          this.validationSnackbar = true

          return
        }

        await this.doCreateEventDate({ eventDate: this.eventDate })

        this.$router.push({ name: 'booking-event', params: { id: this.eventId } })
      },
      ...mapActions({
        doCreateEventDate: 'booking/createEventDate'
      })
    },
    name: 'EventDateAdd'
  }
</script>

<i18n>
  {
    "de": {
      "cancel": "Abbrechen",
      "newDate": "Neuer Termin",
      "save": "Speichern",
      "thereAreItemsThatRequireYourAttention": "Es gibt Felder, die Ihre Aufmerksamkeit erfordern."
    },
    "en": {
      "cancel": "Cancel",
      "newDate": "New date",
      "save": "Save",
      "thereAreItemsThatRequireYourAttention": "There are items that require your attention."
    }
  }
</i18n>